import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '@/shared/utils/cn';

export interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  className?: string;
  ctaSlot?: ReactNode;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  className,
  ctaSlot,
}: EmptyStateProps) {
  return (
    <div className={cn('flex w-full items-center justify-center py-16', className)}>
      <div className="mx-auto flex max-w-md flex-col items-center text-center">
        <Icon aria-hidden="true" className="h-12 w-12 text-fg-subtle" />
        <h2 className="mt-4 text-base font-medium text-fg">{title}</h2>
        <p className="mt-1 text-sm text-fg-muted">{description}</p>
        {ctaSlot ? <div className="mt-6">{ctaSlot}</div> : null}
      </div>
    </div>
  );
}
